import { connect } from 'react-redux'
import SettingsMenu from '../components/SettingsMenu'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { user } = state.authentication
  return ({
    width,
    user,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsMenu)


// WEBPACK FOOTER //
// ./src/Pages/Settings/containers/SettingsMenu.js